import { render, staticRenderFns } from "./FillDescription.vue?vue&type=template&id=12ca1482&scoped=true&"
import script from "./FillDescription.vue?vue&type=script&lang=js&"
export * from "./FillDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ca1482",
  null
  
)

export default component.exports